import _ from 'lodash';
import Vue from 'vue';
import { defineStore } from 'pinia';

// module for containing errors
// errors support scoping by formatting key names like "<scope>:<key>". global scope is assumed when only "<key>" is used.
// some getters below support scoping as optional parameter -- if not specified global scope is assumed.
// 2022 update - scoping can also be more easily enabled by using startScope and endScope (exposed on the validation object).

export const useErrorStore = defineStore('coveError', {
  state () {
    return {
      scope: null,
      errors: []
    };
  },
  getters: {
    getAllErrors () {
      return (scope) => {
        return this._getScopedErrors(scope);
      };
    },
    getAllErrorMessages () {
      return (scope) => {
        return this._getScopedErrors(scope).map((e) => {
          return e.message;
        });
      };
    },
    hasErrors () {
      return (scope) => {
        return this._getScopedErrors(scope).length > 0;
      };
    },
    hasFieldErrors () {
      // scope is already built into the key name so no additional filtering needed here
      return (key) => {
        let error = this.errors.find((e) => {
          return e.key === key;
        });

        return error !== undefined;
      };
    },
    _getScopedErrors () {
      return (scope) => {
        let result = [];
        let prefix = '';
        if (!_.isEmpty(scope))
        {
          prefix = scope + ':';
        }
        else if (!_.isEmpty(this.scope))
        {
          prefix = this.scope + ':';
        }

        if (!_.isEmpty(prefix))
        {
          this.errors.forEach((e) => {
            if (e.key.startsWith(prefix))
            {
              result.push(e);
            }
          });
        }
        else
        {
          this.errors.forEach((e) => {
            if (!e.key.includes(':'))
            {
              result.push(e);
            }
          });
        }

        return result;
      };
    }
  },
  actions: {
    addError ({ key, message }) {
      let prefix = '';
      if (!_.isEmpty(this.scope))
      {
        prefix = this.scope + ':';
      }

      this.errors.push({ key: `${prefix}${key}`, message });
    },
    removeError (key) {
      let prefix = '';
      if (!_.isEmpty(this.scope))
      {
        prefix = this.scope + ':';
      }

      let index = _.findIndex(this.errors, ['key', `${prefix}${key}`]);
      if (index >= 0)
      {
        Vue.delete(this.errors, index);
      }
    },
    clear (scope) {
      let prefix = '';
      if (!_.isEmpty(scope))
      {
        prefix = scope + ':';
      }
      else if (!_.isEmpty(this.scope))
      {
        prefix = this.scope + ':';
      }

      if (!_.isEmpty(prefix))
      {
        this.errors = _.filter(this.errors, (e) => {
          return !e.key.startsWith(prefix);
        });
      }
      else
      {
        this.errors = _.filter(this.errors, (e) => {
          return e.key.includes(':');
        });
      }
    },
    startScope (scope) {
      this.scope = scope;
    },
    endScope () {
      this.scope = null;
    }
  }
});